__turbopack_context__.v({
  "className": "roboto_43f04644-module__4po4Oa__className",
  "variable": "roboto_43f04644-module__4po4Oa__variable",
});
